import React from 'react';
import { WebsiteDesignProps } from './types';
import { HeartPulse, Stethoscope, Microscope } from 'lucide-react';
import { Button } from "@/components/ui/button";

const MedicalSchool: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "College of Medicine";

    return (
        <div className="bg-white text-slate-600 min-h-screen font-sans">
            <nav className="flex justify-between items-center px-8 py-6 bg-white border-b border-gray-100">
                <div className="text-2xl font-serif text-slate-800 flex items-center gap-3">
                    <HeartPulse className="text-red-500" /> {schoolName}
                </div>
                <div className="flex gap-4">
                    <Button variant="ghost" className="text-slate-600 font-medium">Research</Button>
                    <Button variant="ghost" className="text-slate-600 font-medium">Education</Button>
                    <Button variant="ghost" className="text-slate-600 font-medium">Patient Care</Button>
                </div>
            </nav>

            <header className="py-20 px-8 container mx-auto flex flex-col items-center text-center">
                <div className="bg-blue-50 text-blue-800 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider mb-8">
                    Applications Open for Class of 2027
                </div>
                <h1 className="text-5xl md:text-7xl font-serif text-slate-900 mb-8 max-w-4xl leading-tight">
                    Dedicated to the <br/> <i className="text-blue-600">Preservation</i> of Life.
                </h1>
                <p className="text-xl text-slate-500 mb-12 max-w-2xl leading-relaxed">
                    We educate the compassionately committed healthcare leaders of tomorrow through integrated clinical experience and scientific inquiry.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full max-w-md">
                     <Button className="w-full h-14 bg-slate-900 text-white font-medium text-lg">
                         MD Program
                     </Button>
                     <Button className="w-full h-14 bg-white border border-slate-200 text-slate-900 font-medium text-lg hover:bg-slate-50">
                         PhD Program
                     </Button>
                </div>
            </header>

            <section className="bg-slate-50 py-20">
                <div className="container mx-auto px-8">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="bg-white p-8 rounded shadow-sm border border-gray-100">
                             <Stethoscope className="text-blue-600 mb-6" size={40} />
                             <h3 className="text-xl font-bold text-slate-900 mb-3">Clinical Skills</h3>
                             <p className="text-slate-500">Early patient contact and simulation labs to build confidence.</p>
                        </div>
                        <div className="bg-white p-8 rounded shadow-sm border border-gray-100">
                             <Microscope className="text-blue-600 mb-6" size={40} />
                             <h3 className="text-xl font-bold text-slate-900 mb-3">Biomedical Science</h3>
                             <p className="text-slate-500">Foundational knowledge enabling the understanding of disease.</p>
                        </div>
                        <div className="bg-white p-8 rounded shadow-sm border border-gray-100">
                             <HeartPulse className="text-blue-600 mb-6" size={40} />
                             <h3 className="text-xl font-bold text-slate-900 mb-3">Public Health</h3>
                             <p className="text-slate-500">Addressing systemic health challenges in our local communities.</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MedicalSchool;
